import React from 'react';
import SearchBar from '../../atoms/SearchBar/SearchBar';
import Pagination from '../../atoms/Pagination/Pagination';
import Loader from '../../atoms/Loader/Loader';
import EmployeesContainer from '../EmployeesContainer/EmployeesContainer';
import '../EmployeesContainer/EmployeesContainer.scss';

const EmployeeListContainer = ({ dataToDisplay, profile, handlePageLink, pageNumbers, loading, prevPage, nextPage, totalProfile, activePage, profileRange, searchResult, onChangeSearch, onPressCancelSearch, searchString, variant = "active" }) => {
    return (
        <div className='employee-list-container card-border card-body'>
            <div className='employee-list-toolbar'>
                <div className='employee-list-count'>
                    Result {profileRange} of {totalProfile}
                </div>
                {/* <div className='col-end-7 col-span-2'>
                    <div className="search-input flex items-center relative">
                        <div className='absolute left-5'>
                            <img src='/svg/searchIcon.svg' alt='search-icon' />
                        </div>
                        <SearchBar
                            placeholder='Search By Name, Email'
                            type='text'
                            id="search-bar"
                            name="search-bar"
                            value={searchString}
                            onChange={onChangeSearch}
                        />
                        {searchString.length >= 1 && (
                            <button className='absolute right-5' onClick={onPressCancelSearch}>
                                <img src='/svg/CrossIcon.svg' alt='cross' />
                            </button>
                        )}
                    </div>
                </div> */}
            </div>
            {!loading ? (
                <>
                    <EmployeesContainer profiles={profile} searchString={searchString} searchResult={searchResult} variant={variant} />
                    <Pagination
                        className="employees-pagination"
                        pageNumbers={pageNumbers}
                        handlePageLink={handlePageLink}
                        prevPage={prevPage}
                        nextPage={nextPage}
                        totalProfile={totalProfile}
                        activePage={activePage}
                        dataToDisplay={dataToDisplay}
                    />
                </>
            ) : (
                <Loader />
            )}
        </div>
    );
};

export default EmployeeListContainer;